import React, {useState, useEffect} from 'react';
import Modal from 'react-modal';
import FolderSelection from '../widgets/FolderSelection';
import '../../styles/partials/components/_modal.scss';
import FolderIcon from '../../images/folder.svg';
import {useLocation} from "react-router-dom";
import folders from "../../services/api/folders";
import notes from "../../services/api/notes";
import ReactGA from 'react-ga';
import Plaudy from "plaudy";

const MoveModal = ({ isOpen, closeModal, entityType, entity }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let folder = location.pathname.replace('/', '');
    setCurrentFolder(folder);
  }, [isOpen]);

  Modal.setAppElement('#root');

  const moveFolders = async () => {
    try {
      setIsLoading(true);
      const {data} = await folders.move({folder: currentFolder || 'home', ids: [entity.id]});

      ReactGA.event({
        category: 'Usage',
        action: 'Moved Folders',
      });
      Plaudy.track('move folder');

      setError(null);
      closeModal();
      window.location.href = `/${currentFolder}`;
    } catch (e) {
      setError('') // TODO: Show error
    } finally {
      setIsLoading(false);
    }
  };

  const moveNotes = async () => {
    try {
      setIsLoading(true);
      const {data} = await notes.move({folder: currentFolder || 'home', ids: entity.notes.map(note => note.id)});

      ReactGA.event({
        category: 'Usage',
        action: 'Moved Notes',
      });
      Plaudy.track('move notes');

      setError(null);
      closeModal();
      window.location.href = `/${currentFolder}`;
    } catch (e) {
      setError('') // TODO: Show error
    } finally {
      setIsLoading(false);
    }
  };

  const handleMove = async () => {
    if (entityType === 'notes') {
      await moveNotes();
    } else {
      await moveFolders();
    }
  };

  const handleCancel = async () => {
    // TODO: Cancel the request
    closeModal();
  };

  const shouldBeDisabled = () => {
    if (entityType) {
      const isVideoEntity = entityType === 'notes';
      const folderAbove = isVideoEntity ? entity.notes[0].folderAbove : entity.folderAbove;
      const isAlreadyInOwnFolder = folderAbove === currentFolder;
      const isMovingRootToRoot = !folderAbove && currentFolder === '';
      return (isLoading || isAlreadyInOwnFolder || isMovingRootToRoot);
    } else {
      return false;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Move Modal"
      onRequestClose={closeModal}
      className="modal"
      overlayClassName="modal-overlay"
    >
      <div className="modal-title">
        <img src={FolderIcon} alt="Folder" />
        <h2>{`Move ${entityType}`}</h2>
      </div>
      <div className="modal-body">
        <FolderSelection
          currentFolder={currentFolder}
          setCurrentFolder={setCurrentFolder}
          entity={entity}
        />
      </div>
      <div className="modal-footer">
        <div className="button-group">
          <a className="button-secondary" onClick={handleCancel}>Cancel</a>
          <a className={`button-primary ${shouldBeDisabled() ? 'disabled' : '' }`} onClick={handleMove}>Move</a>
        </div>
      </div>
    </Modal>
  );
};

export default MoveModal;
